"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _geolib = _interopRequireDefault(require("geolib"));
var _commonLibs = require("@mmc/common-libs");
var _commonSetLocation = require("@mmc/common-set-location");
var _templateObject;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var isGoogleMapsAvailable = function isGoogleMapsAvailable() {
  return typeof window !== 'undefined' && window.google;
};
var mapApiLoaded = function mapApiLoaded(googleAPIKey, region, language) {
  if (isGoogleMapsAvailable()) {
    return Promise.resolve();
  }
  return new Promise(function (resolve) {
    (0, _commonLibs.loadScript)({
      google: (0, _commonLibs.getGoogleApiURL)({
        apiKey: googleAPIKey,
        libraries: ['places', 'geometry'],
        region: region || null,
        language: language || null
      })
    }).google.onLoad(resolve);
  });
};
var replaceLanguageMasters = function replaceLanguageMasters(region) {
  return region === 'language-masters' ? 'gb' : region;
};
var DEALERS = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query searchDealer(\n    $latitude: Float!\n    $longitude: Float!\n    $market: String!\n    $language: String!\n    $service: DepartmentCode\n    $radius: Float!\n    $vehicle: String\n    $vehicleYearsParams: String\n    $inventoryModel: String\n    $inventoryColour: String\n    $filters: String\n    $path: String\n    $province: String\n  ) {\n    searchDealer(\n      path: $path\n      criteria: {\n        latitude: $latitude\n        longitude: $longitude\n        market: $market\n        language: $language\n        radius: $radius\n        service: $service\n        vehicle: $vehicle\n        vehicleYearsParams: $vehicleYearsParams\n        inventoryModel: $inventoryModel\n        inventoryColour: $inventoryColour\n        filters: $filters\n        province: $province\n      }\n    ) {\n      name\n      id\n      dealershipMarketId\n      url\n      carServiceCTA\n      testDriveCTA\n      email\n      rating\n      logo\n      phone {\n        phoneType\n        countryCode\n        areaCode\n        phoneNumber\n        extensionNumber\n      }\n      address {\n        addressLine1\n        addressLine2\n        addressLine3\n        longitude\n        latitude\n        postalArea\n        municipality\n        district\n        city\n      }\n      phone {\n        phoneType\n        countryCode\n        areaCode\n        phoneNumber\n        extensionNumber\n      }\n      dealerDepartments {\n        name\n        code\n        email\n        phone {\n          phoneType\n          countryCode\n          areaCode\n          phoneNumber\n          extensionNumber\n        }\n        workingHours {\n          dayOfTheWeek\n          openTime\n          closeTime\n          status\n        }\n      }\n    }\n  }\n"])));
var DealerLocatorTools = /*#__PURE__*/function () {
  function DealerLocatorTools() {}
  DealerLocatorTools.query = function query() {
    return DEALERS;
  };
  DealerLocatorTools.autoCompleteCallback = function autoCompleteCallback(inputElement, changeFunction, region) {
    var autoComplete = new window.google.maps.places.Autocomplete(inputElement, {
      types: ['(regions)'],
      componentRestrictions: {
        country: replaceLanguageMasters(region)
      }
    });
    autoComplete.addListener('place_changed', changeFunction);
  };
  DealerLocatorTools.bindAutoComplete = function bindAutoComplete(params) {
    var _this = this;
    var inputElement = params.inputElement,
      changeFunction = params.changeFunction,
      googleAPIKeyFromConfig = params.googleAPIKeyFromConfig,
      region = params.region,
      language = params.language;
    if (isGoogleMapsAvailable()) {
      this.autoCompleteCallback(inputElement, changeFunction);
    }
    mapApiLoaded(googleAPIKeyFromConfig, region, language).then(function () {
      return _this.autoCompleteCallback(inputElement, changeFunction, region);
    });
  };
  DealerLocatorTools.formatDealers = function formatDealers(dealers, market) {
    var _this2 = this;
    return dealers.map(function (dealer) {
      return _this2.formatDealer(dealer, null, market);
    });
  };
  DealerLocatorTools.listByDistance = function listByDistance(dealers, location, measurementSystem, market) {
    var _this3 = this;
    return dealers.map(function (dealer) {
      return _this3.formatDealer(_this3.setDealerDistance(dealer, location, measurementSystem), measurementSystem, market);
    }).sort(function (a, b) {
      return a.distance - b.distance;
    });
  };
  DealerLocatorTools.formatDealer = function formatDealer(dealer, measurementSystem, market) {
    var defaultAddressOrder = [dealer.address.addressLine1, dealer.address.addressLine2, dealer.address.addressLine3, dealer.address.city, dealer.address.postalArea, dealer.address.municipality, dealer.address.district];
    var addressOrderMap = {
      us: [dealer.address.addressLine1, dealer.address.addressLine2, dealer.address.addressLine3, dealer.address.postalArea, dealer.address.municipality, dealer.address.district],
      nl: [dealer.address.addressLine1, dealer.address.postalArea, dealer.address.addressLine2, dealer.address.addressLine3, dealer.address.city, dealer.address.municipality, dealer.address.district]
    };
    var addressOrder = addressOrderMap[market.toLowerCase()] ? addressOrderMap[market.toLowerCase()] : defaultAddressOrder;
    var address = dealer.address && addressOrder.filter(Boolean).join(', ');
    var distance = measurementSystem === 'imperial' ? dealer.distance / 1.609344 : dealer.distance;
    return _objectSpread(_objectSpread({}, dealer), {}, {
      distance: distance ? distance.toFixed(2) : undefined,
      dealerLocation: dealer.address,
      address: address
    });
  };
  DealerLocatorTools.setDealerDistance = function setDealerDistance(dealer, userLocation, measurementSystem) {
    var metersPerKm = 1000;
    var mutatedWithDummyDataDealer = _objectSpread({}, dealer);

    // Add Distance from Dealer to Entered Location
    var distance = _geolib["default"].getDistance({
      latitude: userLocation.lat,
      longitude: userLocation.lng
    }, {
      latitude: dealer.address.latitude,
      longitude: dealer.address.longitude
    }) / metersPerKm;
    if (measurementSystem === 'imperial') {
      // calculate distance in miles in markets with miles
      var convertKMToMiles = function convertKMToMiles(distanceInKM) {
        var milesToKm = 1.609344;
        distance = distanceInKM / milesToKm;
      };
      convertKMToMiles(distance);
    }
    mutatedWithDummyDataDealer = _objectSpread(_objectSpread({}, mutatedWithDummyDataDealer), {}, {
      distance: parseFloat(distance.toFixed(2))
    });
    return mutatedWithDummyDataDealer;
  };
  DealerLocatorTools.geoCoderCallback = function geoCoderCallback(query, successCallback, errorCallback) {
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      address: query
    }, function (results, status) {
      if (results && status === window.google.maps.GeocoderStatus.OK) {
        var coords = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        var stateCode = (0, _commonSetLocation.getStateCodeFromGooglePlaceResults)(results);
        var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
        var city = (0, _commonSetLocation.getCityFromGooglePlaceResults)(results);
        successCallback(coords, stateCode, postalCode, city);
      } else {
        errorCallback(status);
      }
    });
  };
  DealerLocatorTools.geocode = function geocode(params) {
    var _this4 = this;
    var query = params.query,
      successCallback = params.successCallback,
      errorCallback = params.errorCallback,
      googleAPIKeyFromConfig = params.googleAPIKeyFromConfig,
      region = params.region,
      language = params.language;
    if (isGoogleMapsAvailable()) {
      this.geoCoderCallback(query, successCallback, errorCallback);
    }
    mapApiLoaded(googleAPIKeyFromConfig, region, language).then(function () {
      return _this4.geoCoderCallback(query, successCallback, errorCallback);
    });
  };
  DealerLocatorTools.getLocation = function getLocation(successFunction, errorFunction) {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        if (successFunction) {
          var geocoder = new window.google.maps.Geocoder();
          var myLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          geocoder.geocode({
            location: myLocation
          }, function (results, status) {
            if (status === window.google.maps.GeocoderStatus.OK) {
              var stateCode = (0, _commonSetLocation.getStateCodeFromGooglePlaceResults)(results);
              successFunction(myLocation, stateCode);
            } else {
              errorFunction(status);
            }
          });
        }
      }, function (error) {
        if (errorFunction) {
          errorFunction(error);
        }
      }, {
        timeout: 5000
      });
    }
  };
  DealerLocatorTools.destroy = function destroy(inputElement) {
    window.google.maps.event.clearInstanceListeners(inputElement);
  };
  return DealerLocatorTools;
}();
exports["default"] = DealerLocatorTools;